import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import styles from './index.css';

const SupportList = (props) => {
    const { content } = props;

    return (
        <div className={styles.supportList}>
            {
                content.map((item, index) => {
                    return (
                        <div className={styles.support} key={index}>
                            <div className={styles.name}>{item.name}</div>
                            <div className={styles.imgWp}>
                                <img src={formatImageWebpAuto(item.image, 319, 128)} alt="" />
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

SupportList.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(SupportList);
